import { map } from 'rxjs';

// Regular expression to match ISO 8601 date strings
const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})$/;
// Convenience function to check if a string matches the date regex
const isDate = (s: any) => dateRegex.test(s);

// This is the decorator function. Its purpose is to hook into methods which return observable streams of data and
// transform any date strings in the returned data into JavaScript Date objects. It will work recursively through objects and arrays.
// Here are the parameters:
// target is the "this" context that the method which is decorated belongs to
// propertyKey is the name of the method which is decorated
// descriptor is the property descriptor of the method which is decorated
export function TransformDates(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    // Store the reference to the original method being decorated
    const originalMethod = descriptor.value;

    // Replace the original method with a new function that adds date transformation logic
    descriptor.value = function (...args: any[]) {
        return originalMethod.apply(this, args).pipe?.(map((data: any) => convertDatesInObject(data)));
    };

    // Be sure to return the modified descriptor so that JavaScript uses the new method you've created instead of the original.
    return descriptor;
}

// This function takes an object (which may be an array, a date string, or a nested object) and recursively
// converts any date strings it finds into JavaScript Date objects.
function convertDatesInObject(obj: any): any {
    if (obj === null || obj === undefined) {
        return obj;
    }

    if (isDate(obj)) {
        return new Date(obj);
    }

    if (Array.isArray(obj)) {
        return obj.map((item) => convertDatesInObject(item));
    }

    if (typeof obj === 'object') {
        Object.keys(obj).forEach((key) => {
            obj[key] = convertDatesInObject(obj[key]);
        });

        return obj;
    }

    return obj;
}
